import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  initialQuestionIds,
  responseIds,
} from '@aldebaran/common/constants/kb';
import { recordResponses } from '../reducers/graph';
import { RootState } from '../types/graph';
import { usePatientDataCollectionConfig } from './usePatientDataCollectionConfig';

export const useInjectProfession = () => {
  const dispatch = useDispatch();
  const config = usePatientDataCollectionConfig();
  const currentPage = useSelector(
    (state: RootState) => state.graph.currentPage,
  );
  const response = useSelector(
    (state: RootState) => state.kb.responses[responseIds.PROFESSION],
  );

  return useCallback(
    (profession?: string | null) => {
      if (!response || !config.PROFESSION.enabled) return;
      dispatch(
        recordResponses({
          questionId: initialQuestionIds.PROFESSION,
          currentPage,
          responses: [
            { ...response, value: { value: profession?.trim() ?? '' } },
          ],
        }),
      );
    },
    [dispatch, currentPage, response, config],
  );
};
